import React from 'react'
import RegistrationForm from '../components/SignUpEmployer/RegistrationForm'
import NavBar from '../components/SignUpEmployer/NavBar'
import Footer from '../components/Footer'

function SignUpEmployer() {
  return (
    <div>
        <NavBar />
        <RegistrationForm />
        <Footer />
    </div>
  )
}

export default SignUpEmployer